import { STATIC_STORAGE_URL } from '@nexxt/common/constants';
import * as React from 'react';
import { ALERT_MESSAGE_TYPES } from '../../../interface/project.interface';
import InfoPopup from '../InfoPopup';
import { Notes } from '../notes';

interface ProjectLockPopupProps {
    show: boolean;
    projectId: number;
    currentLockUser: {
        userId?: number;
        firstName?: string;
        lastName?: string;
        email?: string;
        isValid: boolean;
    };
    onClose: () => void;
    changePath: (path: string) => void;
    setEditEnabled: (toggle: boolean) => void;
    updateProjectLockUser: (projectId: number, data: any) => Promise<any>;
}

const ProjectLockPopup: React.FC<ProjectLockPopupProps> = (
    props: ProjectLockPopupProps
) => {
    const setReadOnlyMode = () => {
        props.onClose();
        props.setEditEnabled(false);
    };
    const takeoverLock = () => {
        props.onClose();
        props.updateProjectLockUser(props.projectId, {
            mode: 'UPDATE'
        });
    };
    const { currentLockUser } = props;
    const lockUser = currentLockUser?.firstName
        ? `${currentLockUser.firstName} ${currentLockUser.lastName} (${currentLockUser.email})`
        : 'someone';
    const lockUserAlt = currentLockUser?.firstName
        ? `${currentLockUser.firstName} ${currentLockUser.lastName}`
        : 'the current user';
    const contents = (
        <>
            <p>
                Uh-oh! It looks like <b>{lockUser}</b> is currently editing this
                project.
            </p>
            <p>Do you want to take over editing?</p>
            <Notes
                type={ALERT_MESSAGE_TYPES.WARN}
                note={`If you take over, ${lockUserAlt} may be interrupted. You may want to contact them before taking over, just to be safe!`}
            />
        </>
    );
    const footer = (
        <>
            <button
                className="btn btn--xs btn--orange"
                onClick={setReadOnlyMode}
            >
                Browse in read-only mode
            </button>
            <button className="btn btn--xs btn--green" onClick={takeoverLock}>
                Take over editing
            </button>
        </>
    );
    return (
        <InfoPopup
            {...props}
            title="Project Takeover"
            icon={`${STATIC_STORAGE_URL}/img/svg/warning-icon.svg`}
            content={contents}
            footer={footer}
            responsiveSize
        />
    );
};

export default ProjectLockPopup;
